require('./bootstrap');
require('slick-carousel');
require('./jdTab');
require('./rotator');
require('./main');
require('./home');
require('./parallax');
require('./inview');
require('./reel');
require('./videomodal');